module.exports = __webpack_public_path__ + "img/error-delete.35b2008f.svg";